import { Pencil } from "lucide-react";
import NoIndex from "../../../components/NoIndex";
import { ToastContainer } from "react-toastify";

export default function ItemViewModal({
  viewModalItem,
  setViewModalItem,
  viewModalTab,
  setViewModalTab,
  editModalOpen,
  setEditModalOpen,
  fetchRacks,
  getSubCategories,
  setSubCategories,
  rackList,
  editableDetails,
  handleDetailChange,
  previewImage,
  handleCatalogImageChange,
  handleSaveCatalog,
  availability,
  handleAvailabilityChange,
  handleSaveAvailability,
  selectedPrinter,
  setSelectedPrinter,
  printerList,
  handleSavePrinter,
  handleAddPrinter,
  getRecipeIngredients,
  setIngredients,
  setIngredientsModalOpen,
  subCategories,
}) {
  const selectedPrice = viewModalItem?.prices?.[0] || {};

  if (!viewModalItem) return null;

  return (
    <>
      <NoIndex />
<ToastContainer/>

      <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 montserrat-font-1">
        <div className="bg-white w-[900px] rounded-xl shadow-xl max-h-[90vh] flex flex-col montserrat-font-1 overflow-hidden montserrat-font-1">
          {/* HEADER */}

          <div className="flex justify-between items-center px-6 py-4 border-b bg-white shrink-0 montserrat-font-1">
            <h2 className="text-lg font-semibold">{viewModalItem.item_name}</h2>

            <button
              onClick={() => setViewModalItem(null)}
              className="text-gray-400 text-xl"
            >
              ✕
            </button>
          </div>

          {/* TABS */}

          <div className="flex gap-2 px-6 pt-3 border-b bg-white shrink-0 montserrat-font-1">
            <button
              onClick={() => setViewModalTab("details")}
              className={`px-4 py-2 text-sm ${
                viewModalTab === "details"
                  ? "border-b-2 border-blue-500 text-blue-600"
                  : ""
              }`}
            >
              Details
            </button>

            <button
              onClick={() => setViewModalTab("availability")}
              className={`px-4 py-2 text-sm ${
                viewModalTab === "availability"
                  ? "border-b-2 border-blue-500 text-blue-600"
                  : ""
              }`}
            >
              Availability
            </button>

            <button
              onClick={() => setViewModalTab("printer")}
              className={`px-4 py-2 text-sm ${
                viewModalTab === "printer"
                  ? "border-b-2 border-blue-500 text-blue-600"
                  : ""
              }`}
            >
              Printer
            </button>
          </div>

          {/* BODY */}

          <div className="flex-1 overflow-y-auto p-6 montserrat-font-1 ">
            {viewModalTab === "details" && !editModalOpen && (
              <>
                <div className="flex justify-between items-center mb-4 montserrat-font-1">
                  <h3 className="text-sm font-semibold">Item Overview</h3>

                  <button
                    onClick={async () => {
                      setEditModalOpen(true);

                      await fetchRacks();

                      const subs = await getSubCategories("");

                      setSubCategories(subs);
                    }}
                    className="flex items-center gap-1 text-blue-600 text-sm hover:underline"
                  >
                    <Pencil size={14} />
                    Edit
                  </button>
                </div>

                <div className="grid grid-cols-[180px_1fr_1fr] gap-6 montserrat-font-1">
                  {/* IMAGE */}

                  <div>
                    <img
                      src={viewModalItem.photo}
                      className="w-[170px] h-[170px] rounded-lg object-cover border"
                    />
                  </div>

                  {/* BASIC DETAILS */}

                  <div className="border rounded-lg p-4">
                    {/* Header */}

                    <div className="flex justify-between mb-3">
                      <h4 className="text-sm font-semibold">Basic Details</h4>

                      <span className="text-xs bg-gray-100 px-2 py-1 rounded">
                        ID: {viewModalItem.item_id}
                      </span>
                    </div>

                    <div className="space-y-3 text-sm">
                      {/* Name */}

                      <div>
                        <p className="text-gray-400 text-xs">Name</p>
                        <p className="font-medium">{viewModalItem.item_name}</p>
                      </div>

                      {/* Category */}

                      <div>
                        <p className="text-gray-400 text-xs">Category</p>
                        <p>{viewModalItem.category_name || "-"}</p>
                      </div>

                      {/* Tags */}

                      <div className="flex gap-2 text-xs flex-wrap">
                        <span className="bg-gray-100 px-2 py-1 rounded">
                          SubCat ID: {viewModalItem.sub_category || "-"}
                        </span>

                        <span className="bg-gray-100 px-2 py-1 rounded">
                          Rack: {viewModalItem.rackNumber || "-"}
                        </span>

                        <span className="bg-gray-100 px-2 py-1 rounded">
                          Expiry: {viewModalItem.expiryDate || "-"}
                        </span>
                      </div>

                      {/* Sub Category */}

                      <div>
                        <p className="text-gray-400 text-xs">Sub-category</p>
                        <p>{viewModalItem.sub_category || "-"}</p>
                      </div>

                      {/* Variant */}

                      <div>
                        <p className="text-gray-400 text-xs">Variant</p>
                        <p>{selectedPrice.variantName || "-"}</p>
                      </div>

                      {/* Stock */}

                      <div>
                        <p className="text-gray-400 text-xs">Stock</p>
                        <p className="font-medium">{viewModalItem.stock}</p>
                      </div>
                    </div>
                  </div>

                  {/* PRICE ROW */}

                  <div className="border rounded-lg p-4">
                    <h4 className="text-sm font-semibold mb-3">
                      Selected Price Row
                    </h4>

                    <div className="space-y-2 text-sm">
                      <div className="flex justify-between">
                        <span>Selling</span>
                        <span>₹{selectedPrice.price}</span>
                      </div>

                      <div className="flex justify-between">
                        <span>Home Delivery</span>
                        <span>₹-</span>
                      </div>

                      <div className="flex justify-between">
                        <span>Takeaway</span>
                        <span>₹-</span>
                      </div>

                      <div className="flex justify-between">
                        <span>Dining</span>
                        <span>₹-</span>
                      </div>

                      <div className="flex justify-between">
                        <span>Car Order</span>
                        <span>₹-</span>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* view details model */}

            {viewModalTab === "details" && editModalOpen && (
              <div className="flex gap-2 px-6 montserrat-font-1">
                <div className="bg-white w-[900px] rounded-xl max-h-[90vh]">
                  {/* BODY */}

                  {/* HEADER ROW */}

                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-sm font-semibold">Item Overview</h3>

                    <button
                      onClick={() => setEditModalOpen(false)}
                      className="text-blue-600 text-sm flex items-center gap-1"
                    >
                      <Pencil size={14} />
                      Cancel
                    </button>
                  </div>

                  {/* CONTENT */}

                  <div className="grid grid-cols-[180px_1fr] gap-6 items-start">
                    {/* LEFT IMAGE */}

                    <div>
                      <img
                        src={previewImage || viewModalItem.photo}
                        className="w-[160px] h-[160px] rounded-lg object-cover"
                      />
                    </div>

                    {/* RIGHT FORM */}

                    <div className="space-y-4">
                      {/* IMAGE */}

                      <div>
                        <label className="text-sm font-medium">
                          Update Image
                        </label>

                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleCatalogImageChange}
                          className="border rounded w-full px-3 py-2 text-sm mt-1"
                        />

                        <p className="text-xs text-gray-500 mt-1">
                          Choose a new image to override the current one.
                        </p>
                      </div>

                      <div className="grid grid-cols-2 gap-4">
                        {/* ITEM NAME */}

                        <div>
                          <label className="text-sm font-medium">
                            Item Name
                          </label>

                          <input
                            name="item_name"
                            value={editableDetails.item_name || ""}
                            onChange={handleDetailChange}
                            className="border rounded w-full px-3 py-2 text-sm mt-1"
                          />
                        </div>

                        {/* DESCRIPTION */}

                        <div>
                          <label className="text-sm font-medium">
                            Description
                          </label>

                          <input
                            name="item_description"
                            value={editableDetails.item_description || ""}
                            onChange={handleDetailChange}
                            className="border rounded w-full px-3 py-2 text-sm mt-1"
                          />
                        </div>

                        {/* SUB CATEGORY */}

                        <div>
                          <label className="text-sm font-medium">
                            Sub-category
                          </label>

                          <select
                            name="sub_category"
                            value={editableDetails.sub_category || ""}
                            onChange={handleDetailChange}
                            className="border rounded w-full px-3 py-2 text-sm text-gray-700"
                          >
                            <option value="">Select Subcategory</option>

                            {subCategories.map((sc) => (
                              <option key={sc.id} value={sc.id}>
                                {sc.subCategory || sc.category}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* RACK */}

                        <div>
                          <label className="text-sm font-medium">
                            Rack Number
                          </label>
                          <select
                            name="rackNumber"
                            value={editableDetails.rackNumber || ""}
                            onChange={handleDetailChange}
                            className="border rounded w-full px-3 py-2 text-sm"
                          >
                            <option value="">Select Rack</option>

                            {rackList.map((rack) => {
                              const tags = rack.tags?.join(", ");

                              return (
                                <option key={rack.id} value={rack.rackNumber}>
                                  {`Rack ${rack.rackNumber} - ${rack.category}${tags ? ` (${tags})` : ""}`}
                                </option>
                              );
                            })}
                          </select>
                        </div>

                        {/* VARIANT */}

                        <div>
                          <label className="text-sm font-medium">Variant</label>

                          <input
                            name="size"
                            value={editableDetails.size || ""}
                            onChange={handleDetailChange}
                            className="border rounded w-full px-3 py-2 text-sm mt-1"
                          />
                        </div>

                        <div>
                          <label className="text-sm font-medium">
                            Tax Percentage
                          </label>
                          <select
                            name="taxPercentage"
                            value={editableDetails.taxPercentage || ""}
                            onChange={handleDetailChange}
                            className="border rounded w-full px-3 py-2 text-sm"
                          >
                            <option value="">Select Tax</option>

                            <option value="5">5%</option>
                            <option value="12">12%</option>
                            <option value="18">18%</option>
                          </select>
                        </div>

                        <div>
                          <label className="text-sm font-medium">Size</label>
                          <input
                            name="size"
                            value={editableDetails.size || ""}
                            onChange={handleDetailChange}
                            placeholder="Size"
                            className="border rounded w-full px-3 py-2 text-sm mt-1"
                          />
                        </div>

                        <div>
                          <label className="text-sm font-medium">
                            Expiry Date
                          </label>
                          <input
                            name="expiryDate"
                            type="date"
                            value={editableDetails.expiryDate || ""}
                            onChange={handleDetailChange}
                            className="border rounded w-full px-3 py-2 text-sm mt-1"
                          />
                        </div>

                        <div>
                          <label className="text-sm font-medium">
                            Selling Price
                          </label>
                          <input
                            name="sellingPrice"
                            value={editableDetails.sellingPrice || ""}
                            onChange={handleDetailChange}
                            placeholder="Selling Price"
                            className="border rounded w-full px-3 py-2 text-sm mt-1"
                          />
                        </div>

                        <div>
                          <label className="text-sm font-medium">
                            Home Delivery Price
                          </label>
                          <input
                            name="homeDeliveryPrice"
                            value={editableDetails.homeDeliveryPrice || ""}
                            onChange={handleDetailChange}
                            placeholder="Home Delivery Price"
                            className="border rounded w-full px-3 py-2 text-sm mt-1"
                          />
                        </div>

                        <div>
                          <label className="text-sm font-medium">
                            Takeaway Price
                          </label>
                          <input
                            name="takewayPrice"
                            value={editableDetails.takewayPrice || ""}
                            onChange={handleDetailChange}
                            placeholder="Takeaway Price"
                            className="border rounded w-full px-3 py-2 text-sm mt-1"
                          />
                        </div>

                        <div>
                          <label className="text-sm font-medium">
                            Dining Price
                          </label>
                          <input
                            name="diningPrice"
                            value={editableDetails.diningPrice || ""}
                            onChange={handleDetailChange}
                            placeholder="Dining Price"
                            className="border rounded w-full px-3 py-2 text-sm mt-1"
                          />
                        </div>

                        <div>
                          <label className="text-sm font-medium">
                            Room Order Price
                          </label>
                          <input
                            name="roomOrder"
                            value={editableDetails.roomOrder || ""}
                            onChange={handleDetailChange}
                            placeholder="Room Order Price"
                            className="border rounded w-full px-3 py-2 text-sm mt-1"
                          />
                        </div>

                        <div>
                          <label className="text-sm font-medium">
                            Car Order Price
                          </label>
                          <input
                            name="carOrder"
                            value={editableDetails.carOrder || ""}
                            onChange={handleDetailChange}
                            placeholder="Car Order Price"
                            className="border rounded w-full px-3 py-2 text-sm mt-1"
                          />
                        </div>

                        <div>
                          <label className="text-sm font-medium">
                            Variant Info
                          </label>
                          <input
                            name="variantName"
                            value={editableDetails.variantName || ""}
                            onChange={handleDetailChange}
                            placeholder="Variant Info"
                            className="border rounded w-full px-3 py-2 text-sm mt-1"
                          />
                        </div>
                      </div>
                      <button
                        onClick={handleSaveCatalog}
                        className="bg-emerald-500 hover:bg-emerald-600 text-white px-4 py-2 rounded mb-5"
                      >
                        Save Changes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Avalibility tab */}
            {viewModalTab === "availability" && (
              <div className="p-6 montserrat-font-1">
                <p className="text-sm text-gray-600 mb-6">
                  Configure availability for this item:
                </p>

                <div className="space-y-4">
                  <div className="flex items-center gap-3 text-sm">
                    <input
                      type="radio"
                      name="availability"
                      checked={availability === "home_delivery"}
                      onChange={() => handleAvailabilityChange("home_delivery")}
                      className="w-4 h-4 cursor-pointer"
                    />

                    <span>Home Delivery</span>
                  </div>

                  <div className="flex items-center gap-3 text-sm">
                    <input
                      type="radio"
                      name="availability"
                      checked={availability === "takeaway"}
                      onChange={() => handleAvailabilityChange("takeaway")}
                      className="w-4 h-4 cursor-pointer"
                    />

                    <span>Takeaway</span>
                  </div>

                  <div className="flex items-center gap-3 text-sm">
                    <input
                      type="radio"
                      name="availability"
                      checked={availability === "dining"}
                      onChange={() => handleAvailabilityChange("dining")}
                      className="w-4 h-4 cursor-pointer"
                    />

                    <span>Dine-in</span>
                  </div>
                </div>

                {/* Save Button */}
                <button
                  onClick={handleSaveAvailability}
                  className="mt-6 w-full bg-emerald-600 hover:bg-emerald-700 text-white py-2 rounded"
                >
                  Save Availability
                </button>
              </div>
            )}

            {/* printer tab */}
            {viewModalTab === "printer" && (
              <div className="space-y-5 montserrat-font-1">
                <p className="text-sm text-gray-600">
                  Assign a printer to this item. This ensures the order slip is
                  printed automatically for the selected section.
                </p>

                <select
                  value={selectedPrinter}
                  onChange={(e) => setSelectedPrinter(e.target.value)}
                  className="w-full border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                >
                  <option value="">Select Printer</option>

                  {printerList.map((printer) => (
                    <option key={printer.id} value={printer.id}>
                      {printer.name}
                    </option>
                  ))}
                </select>

                <div className="flex gap-3">
                  <button
                    onClick={handleSavePrinter}
                    className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded text-sm"
                  >
                    Save Printer
                  </button>

                  <button
                    onClick={handleAddPrinter}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm"
                  >
                    Add Printer
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* FOOTER */}

          <div className="flex justify-between items-center border-t px-6 py-4 bg-white shrink-0 mt-3 montserrat-font-1">
            <button
              onClick={() => setViewModalItem(null)}
              className="border px-4 py-2 rounded text-sm"
            >
              Close
            </button>

            <div className="flex gap-3 montserrat-font-1">
              <button
                onClick={async () => {
                  const data = await getRecipeIngredients(
                    viewModalItem.item_id,
                  );
                  setIngredients(data || []);
                  setIngredientsModalOpen(true);
                }}
                className="bg-blue-600 text-white px-4 py-2 rounded text-sm"
              >
                Ingredients Edit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
